import styled from 'styled-components'
import { breakpoints, colors } from 'style'

export const GetStartedStepsContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${colors.white};
  .nav-tabs.get-started-taps {
    padding-left: 30px;
    border-bottom: solid 2px ${colors.dark8};
    .nav-link {
      color: ${colors.blueDark};
      border-width: 4px;
      .tab-item {
        margin-bottom: 0px;
      }
      &.active,
      &:hover {
        border-color: transparent transparent ${colors.blueDark};
        .tab-item {
          color: ${colors.blueDark};
          .tab-order {
            background-color: ${colors.blueDark};
          }
        }
      }
    }
  }
  @media (max-width: ${breakpoints.sm}px) {
    .nav-tabs.get-started-taps {
      padding-left: 0px;
      .nav-link {
        margin-bottom: 2px;
        width: 100%;
        .tab-item {
          font-size: 18px;
        }
      }
    }
  }
  @media (max-width: 413px), (max-height: 845px) {
  }
`

export const TabItemContainer = styled.h3`
  display: flex;
  align-items: center;
  color: #858080;
  .tab-order {
    background-color: #858080;
    border-radius: 50%;
    width: 40px;
    min-width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${colors.white};
    margin-right: 10px;
  }
`
